import { MFAStep } from './mfa-context';

type MFAFormStepProps = {
  currentStep: MFAStep;
  step: MFAStep; // the step this component is responsible for
  children: React.ReactNode;
};

export function MFAFormStep({ currentStep, step, children }: MFAFormStepProps) {
  if (currentStep !== step) {
    return undefined;
  }
  return <div data-testid={`mfa-step-${step}`}>{children}</div>;
}
